import { render, staticRenderFns } from "./poet.vue?vue&type=template&id=19a37ff6&"
import script from "./poet.vue?vue&type=script&lang=js&"
export * from "./poet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports